/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconSocialStarHalf = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M13.905 6.773L10.541 9.25a.5.5 0 0 0-.18.557l1.282 3.959-3.35-2.425A.497.497 0 0 0 8 11.246V2.501l-.001-.003L8 2.495l1.278 3.933a.498.498 0 0 0 .475.345h4.152zm1.998-.656a.5.5 0 0 0-.475-.344h-5.312L8.475.722c-.133-.412-.817-.412-.951 0L5.883 5.773H.571a.5.5 0 0 0-.296.903l4.301 3.163-1.643 5.094a.5.5 0 0 0 .77.558L8 12.364l4.297 3.111a.501.501 0 0 0 .769-.559l-1.642-5.074 4.3-3.166a.501.501 0 0 0 .179-.559z"
    />
  </svg>
);

IconSocialStarHalf.displayName = 'IconSocialStarHalf';

IconSocialStarHalf.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconSocialStarHalf);
IconSocialStarHalf.displayName = 'IconSocialStarHalf';
